import { OpmlError } from '../../errors';
export function transformOpmlResponse(response) {
    if (response.head.status !== '200') {
        throw new OpmlError(response);
    }
    return response.body?.length === 1 ? response.body[0] : response.body;
}
